import React from "react";
import ShowAllNodeInfo from "./NodeInfo/ShowAllNodeInfo";

const NodeInfoPage = () => {

  return (
    <div style={{ backgroundColor: "#333333", height: "89vh", padding: "15px", overflow: "hidden", border: "none" }} className="Admin">
      <div className={"d-flex col-sm-12 white_paper before-login"} style={{ backgroundColor: "#fff", overflow: "hidden", borderRadius: "5px", padding: "0px", height: "100%" }}>
        <ShowAllNodeInfo />
      </div>
    </div>
  );
};

export default NodeInfoPage;
